module.exports = __webpack_public_path__ + "static/media/font_medium.dbd36589.woff2";